import React, { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "../axios";

const LogoPill = ({ navigate }) => (
  <div style={{ marginBottom: "28px", textAlign: "center" }}>
    <div
      style={{
        display: "inline-flex",
        borderRadius: "999px",
        overflow: "hidden",
        boxShadow: "0 4px 12px rgba(4,120,87,0.25)",
        marginBottom: "10px",
        cursor: "pointer",
      }}
      onClick={() => navigate("/")}
    >
      <div style={{ background: "#2C9736", padding: "9px 13px", display: "flex", alignItems: "center" }}>
        <img src="/logo512.png" alt="BusWatch logo" style={{ width: 38, height: 38, display: "block", borderRadius: "50%" }} />
      </div>
      <div style={{ background: "#d1fae5", padding: "9px 20px", display: "flex", alignItems: "center" }}>
        <span style={{ fontSize: "21px", fontWeight: "800", color: "#047857", letterSpacing: "0.5px", whiteSpace: "nowrap" }}>
          西鉄バスWatch!
        </span>
      </div>
    </div>
  </div>
);

const outerStyle = {
  position: "fixed",
  inset: 0,
  overflowY: "auto",
  background: "linear-gradient(180deg, #ecfdf5 0%, #f0fdf4 100%)",
  padding: "48px 16px",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  fontFamily: "system-ui, sans-serif",
};

const cardStyle = {
  width: "100%",
  maxWidth: "400px",
  background: "#ffffff",
  borderRadius: "16px",
  boxShadow: "0 4px 24px rgba(4,120,87,0.10)",
  padding: "36px 28px",
  border: "1px solid #d1fae5",
  boxSizing: "border-box",
  textAlign: "center",
};

const btnStyle = {
  width: "100%",
  padding: "13px",
  borderRadius: "10px",
  border: "none",
  background: "#10b981",
  color: "#fff",
  fontSize: "1rem",
  fontWeight: "700",
  cursor: "pointer",
  boxShadow: "0 2px 10px rgba(16,185,129,0.30)",
  transition: "background 0.2s",
  letterSpacing: "0.04em",
};

// ---- 成功画面 ----
function SuccessView({ navigate }) {
  return (
    <div style={outerStyle}>
      <LogoPill navigate={navigate} />
      <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "10px", marginBottom: "28px" }}>
        <span style={{ width: 24, height: 1, background: "#6ee7b7", borderRadius: 1 }} />
        <p style={{ color: "#065f46", fontWeight: "600", fontSize: "13px", letterSpacing: "0.1em", margin: 0 }}>メール認証完了</p>
        <span style={{ width: 24, height: 1, background: "#6ee7b7", borderRadius: 1 }} />
      </div>
      <div style={cardStyle}>
        <div style={{ marginBottom: "20px" }}>
          <svg width="56" height="56" viewBox="0 0 56 56" fill="none">
            <circle cx="28" cy="28" r="28" fill="#d1fae5" />
            <circle cx="28" cy="28" r="20" fill="#10b981" />
            <polyline points="19,28 25,34 37,22" stroke="#fff" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </div>
        <h2 style={{ fontSize: "1.25rem", fontWeight: "800", color: "#065f46", marginBottom: "12px" }}>認証が完了しました</h2>
        <p style={{ fontSize: "0.9rem", color: "#047857", marginBottom: "28px", lineHeight: "1.7" }}>
          登録したメールアドレスと<br />パスワードでログインしてください。
        </p>
        <button
          onClick={() => navigate("/login")}
          style={btnStyle}
          onMouseOver={(e) => { e.currentTarget.style.background = "#059669"; }}
          onMouseOut={(e) => { e.currentTarget.style.background = "#10b981"; }}
        >
          ログイン画面へ
        </button>
      </div>
    </div>
  );
}

// ---- 期限切れ・無効リンク画面 ----
function ExpiredView({ navigate, initialEmail, isInvalid }) {
  const [email, setEmail] = useState(initialEmail);
  const [status, setStatus] = useState("idle"); // idle | sending | done | error
  const [message, setMessage] = useState("");

  const handleResend = async () => {
    if (!email) return;
    setStatus("sending");
    try {
      await axios.post("/email/resend-verification", { email });
      setStatus("done");
      setMessage("認証メールを再送しました。メールをご確認ください。");
    } catch (err) {
      setStatus("error");
      setMessage(err.response?.data?.message || "送信に失敗しました。しばらく経ってから再試行してください。");
    }
  };

  return (
    <div style={outerStyle}>
      <LogoPill navigate={navigate} />
      <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "10px", marginBottom: "28px" }}>
        <span style={{ width: 24, height: 1, background: "#6ee7b7", borderRadius: 1 }} />
        <p style={{ color: "#065f46", fontWeight: "600", fontSize: "13px", letterSpacing: "0.1em", margin: 0 }}>
          {isInvalid ? "無効なリンク" : "リンクの期限切れ"}
        </p>
        <span style={{ width: 24, height: 1, background: "#6ee7b7", borderRadius: 1 }} />
      </div>
      <div style={cardStyle}>
        <div style={{ marginBottom: "20px" }}>
          <svg width="56" height="56" viewBox="0 0 56 56" fill="none">
            <circle cx="28" cy="28" r="28" fill="#fef3c7" />
            <circle cx="28" cy="28" r="20" fill="#f59e0b" />
            <line x1="28" y1="18" x2="28" y2="30" stroke="#fff" strokeWidth="3" strokeLinecap="round" />
            <circle cx="28" cy="36" r="1.5" fill="#fff" />
          </svg>
        </div>

        {isInvalid ? (
          <>
            <h2 style={{ fontSize: "1.15rem", fontWeight: "800", color: "#065f46", marginBottom: "12px" }}>リンクが無効です</h2>
            <p style={{ fontSize: "0.9rem", color: "#047857", marginBottom: "24px", lineHeight: "1.7" }}>
              このリンクは使用できません。<br />新規登録からやり直してください。
            </p>
            <button onClick={() => navigate("/register")} style={btnStyle}
              onMouseOver={(e) => { e.currentTarget.style.background = "#059669"; }}
              onMouseOut={(e) => { e.currentTarget.style.background = "#10b981"; }}
            >
              新規登録画面へ
            </button>
          </>
        ) : (
          <>
            <h2 style={{ fontSize: "1.15rem", fontWeight: "800", color: "#065f46", marginBottom: "12px" }}>リンクの有効期限が切れています</h2>
            <p style={{ fontSize: "0.9rem", color: "#047857", marginBottom: "24px", lineHeight: "1.7" }}>
              認証リンクの有効期限（60分）が<br />過ぎています。再送信してください。
            </p>

            {status === "done" ? (
              <div style={{ background: "#d1fae5", border: "1px solid #6ee7b7", borderRadius: "8px", padding: "12px 14px", fontSize: "0.875rem", color: "#065f46" }}>
                {message}
              </div>
            ) : (
              <>
                {status === "error" && (
                  <div style={{ background: "#fee2e2", border: "1px solid #fecaca", borderRadius: "8px", padding: "10px 14px", fontSize: "0.875rem", color: "#b91c1c", marginBottom: "16px" }}>
                    {message}
                  </div>
                )}
                <div style={{ marginBottom: "16px", textAlign: "left" }}>
                  <label style={{ display: "block", fontSize: "0.85rem", fontWeight: "600", marginBottom: "6px", color: "#065f46" }}>
                    登録したメールアドレス
                  </label>
                  <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="example@email.com"
                    style={{
                      width: "100%",
                      padding: "11px 14px",
                      borderRadius: "8px",
                      border: "1.5px solid #a7f3d0",
                      fontSize: "1rem",
                      boxSizing: "border-box",
                      background: "#f9fafb",
                      outline: "none",
                    }}
                    onFocus={(e) => { e.target.style.borderColor = "#10b981"; e.target.style.background = "#fff"; }}
                    onBlur={(e) => { e.target.style.borderColor = "#a7f3d0"; e.target.style.background = "#f9fafb"; }}
                  />
                </div>
                <button
                  onClick={handleResend}
                  disabled={status === "sending" || !email}
                  style={{ ...btnStyle, background: (status === "sending" || !email) ? "#6ee7b7" : "#10b981", cursor: (status === "sending" || !email) ? "default" : "pointer" }}
                  onMouseOver={(e) => { if (status !== "sending" && email) e.currentTarget.style.background = "#059669"; }}
                  onMouseOut={(e) => { if (status !== "sending" && email) e.currentTarget.style.background = "#10b981"; }}
                >
                  {status === "sending" ? "送信中…" : "認証メールを再送する"}
                </button>
              </>
            )}
          </>
        )}
      </div>
    </div>
  );
}

export default function VerifiedPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const error = searchParams.get("error");

  if (error === "expired") return <ExpiredView navigate={navigate} initialEmail="" isInvalid={false} />;
  if (error === "invalid") return <ExpiredView navigate={navigate} initialEmail="" isInvalid={true} />;
  return <SuccessView navigate={navigate} />;
}
